export default [
  {
    path     : '/public',
    name     : 'public',
    component: () => import('@/layouts/main/Public'),
    children : [
      {
        path: 'notify-schedules',
        name: 'public.notify-schedules',
        component: () => import('@/views/Public/NotifySchedules'),
        meta: {
          pageTitle: ''
        }
      }
    ]
  }
]